import { Component, forwardRef, Input } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Observable } from 'rxjs';
import { ExternalSelectorComponent } from '../../external-selector/external-selector.component';
import { AgenzieComponent } from 'src/app/anagrafiche/agenzie/agenzie.component';
import { FormGroup } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { Agenzia } from 'src/app/models/agenzia';

@Component({
  providers: [
    { provide: MatFormFieldControl, useExisting: forwardRef(() => AgenziaPickerComponent) },
  ],
  selector: 'agenzia-picker',
  templateUrl: '../../external-selector/external-selector.component.html',
  styleUrls: ['../../external-selector/external-selector.component.scss']
})
export class AgenziaPickerComponent extends ExternalSelectorComponent {
  onChange: any;

  @Input()
  get externalEntityObserver(): Observable<any> {
    return this.dialog.open(AgenzieComponent, {
      data: {
        selectionMode: true,
        defaultSearch: this.defaultSearch,
      }
    }).afterClosed();
  }

  parts: FormGroup = this.fb.group({
    humanIdentifier: [''],
    id: [''],
  });

  registerOnChange(onChange: (value: any) => void): void {
    this.parts.valueChanges.pipe(
      takeUntil(this.destroy),
    ).subscribe((value) => {
      if (value.id) {
        onChange(value);
      } else {
        onChange(null);
      }
    });
  }

  public writeValue(value?: any): any {
    if (value === null || value === undefined) {
      this.parts.reset();
      this.stateChanges.next();
    } else {
      // Handle both object and primitive values
      if (value && typeof value === 'object') {
        this.parts.patchValue({
          humanIdentifier: value.humanIdentifier || value.nome || value.ragione_sociale || '',
          id: value.id
        });
      } else {
        // If it's just an ID, you might want to fetch the full object
        // or set a placeholder until the full object is loaded
        this.parts.patchValue({
          humanIdentifier: '', // Will be updated when full object is loaded
          id: value
        });
      }
      this.stateChanges.next();
    }
  }

  // Override the selection handler to properly update the form
  protected handleSelection(selectedValue: any): void {
    if (selectedValue) {
      const agenzia = new Agenzia().deserialize(selectedValue);
      this.writeValue(agenzia);
      
      // Notify the parent form control
      if (this.onChange) {
        this.onChange(agenzia);
      }
    }
  }

  getRoute = (id: any) => `/agenzie/${id}`;
}